
document.addEventListener('DOMContentLoaded', async () => {
  const section = document.querySelector(
    '[data-random-featured-products]'
  );
  if (!section) return;

  const grid = section.querySelector('.product-grid');
  if (!grid) return;

  grid.style.visibility = 'hidden';

  const collectionUrl = '/collections/nos-coups-de-coeur';
  const pageSize = 24;
  const productsToShow = 8;
  const totalProducts = 357;
  const totalPages = Math.ceil(totalProducts / pageSize);

  try {
    const page = Math.floor(Math.random() * totalPages) + 1;

    const url = `${collectionUrl}?page=${page}&section_id=main-collection-product-grid`;
    const response = await fetch(url);

    if (!response.ok) throw new Error('Chargement impossible');

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const sourceGrid = doc.querySelector('#product-grid');

    if (!sourceGrid) {
      throw new Error('Grille source introuvable');
    }

    const products = Array.from(
      sourceGrid.querySelectorAll('li.grid__item')
    ).filter(product => {
      const soldOutBadge = product.querySelector('.badge');

      return !soldOutBadge ||
        !/épuisé|sold out|ausverkauft/i.test(soldOutBadge.textContent);
    });

    for (let i = products.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [products[i], products[j]] = [products[j], products[i]];
    }

    if (products.length < productsToShow) {
      throw new Error('Pas assez de produits');
    }

    const selected = products.slice(0, productsToShow);
    grid.replaceChildren(...selected);
    grid.style.visibility = 'visible';

    console.log('KILOBOUTIQUE : sélection aléatoire affichée.');
  } catch (error) {
    console.error('KILOBOUTIQUE :', error);
  } finally {
    grid.style.visibility = 'visible';
    section.style.visibility = 'visible';
  }
});
